export default __webpack_public_path__ + "static/media/cover_journal2.fc7aee0e.png";